export default __webpack_public_path__ + "static/cadbury-pattern-c9f73e6e0af08cc76b8a1c4a6794f070.webp";